// extracted by mini-css-extract-plugin
module.exports = {"article":"static-fixed-area_article__vjkiw","floating":"static-fixed-area_floating__K6VR_","inner":"static-fixed-area_inner__8kEUs","scroll":"static-fixed-area_scroll__wqgeG"};